import { FaStar } from 'react-icons/fa';
import { openZohoChat } from '../utils/openZohoChat';
import { PRODUCTS } from '../data/content';
import './Products.css';

const money = (n) =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

export default function Products() {
  return (
    <section className="dh-products" id="products">
      <div className="dh-container">
        <div className="dh-section-head">
          <p className="dh-eyebrow">Licensed Dragon editions</p>
          <h2>Choose the Dragon build that fits your workflow</h2>
          <p>
            Rephrased product picks with clear pricing. Tap Add to cart to chat with a specialist who
            can confirm compatibility and complete your order.
          </p>
        </div>

        <div className="dh-products__grid">
          {PRODUCTS.map((product) => (
            <article className="dh-product-card" key={product.id}>
              <div className="dh-product-card__img">
                <img src={product.image} alt={product.name} width="480" height="320" />
              </div>
              <div className="dh-product-card__body">
                <h3>{product.name}</h3>
                <p>{product.blurb}</p>
                <div className="dh-product-card__rating" aria-label={`${product.rating} out of 5 stars`}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <FaStar key={i} className={i < product.rating ? 'is-on' : ''} aria-hidden />
                  ))}
                </div>
                <div className="dh-product-card__price">
                  <s>{money(product.priceWas)}</s>
                  <strong>{money(product.priceNow)}</strong>
                </div>
                <button type="button" className="dh-btn dh-btn--outline" onClick={openZohoChat}>
                  Add to cart
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
